import './alteration-card-group.scss'

import { defineComponent, PropType } from 'vue'
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'

import { ThesaurusTerm, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import AlterationCardList from '../alteration-card-list'
import { ALTERATION_CARD_ALTERATION_UPDATED, ALTERATION_CARD_DELETE_ALTERATION, AlterationWithThesaurusTerm, MainAlterationCardField } from '../alteration-card'

export enum GroupingAlterationField {
    Title,
    AlterationType,
}

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAlterationCardList: AlterationCardList,
    },
    props: {
        type: Array,
        alterations: {
            type: Array as PropType<AlterationWithThesaurusTerm[]>,
        },
        groupingField: {
            default: GroupingAlterationField.AlterationType
        },
        alterationTypeId: {
            type: String,
        },
        alterationTitle: {
            type: String,
        },
        readOnly: {
            type: Boolean,
        },
        existingTitles: {
            type: Array as PropType<String[]>,
            default:() => []
        },
    },
    template: require('./alteration-card-group.html'),
    data() {
        return {
            isFolded: false,

            groupUnfoldedIcon: faCaretDown,
            groupFoldedIcon: faCaretRight,

            ALTERATION_CARD_DELETE_ALTERATION: ALTERATION_CARD_DELETE_ALTERATION,
            ALTERATION_CARD_ALTERATION_UPDATED: ALTERATION_CARD_ALTERATION_UPDATED,
        }
    },
    computed: {
        groupFoldingIcon(): IconDefinition {
            return this.isFolded ? this.groupFoldedIcon : this.groupUnfoldedIcon
        },

        alterationCardMainField(): MainAlterationCardField {
            switch(this.groupingField) {
                case GroupingAlterationField.AlterationType:
                    return MainAlterationCardField.Title
                case GroupingAlterationField.Title:
                    return MainAlterationCardField.AlterationType
            }
        },

        groupTitle(): string {
            if(this.alterations) {
                switch(this.groupingField) {
                    case GroupingAlterationField.AlterationType:
                        if(this.alterations[0].typeOfAlterationObject){
                            return this.getThesaurusTermTitle(this.alterations[0].typeOfAlterationObject)
                        }
                        break

                    case GroupingAlterationField.Title:
                        return getTranslatedString(this.alterations[0].title, this.getAppLocale())
                }
            }

            return ''
        },
    },
    methods: {
        getThesaurusTermTitle(thesaurusTerm: ThesaurusTerm) {
            return getTranslatedString(
                thesaurusTermSelectors.preferredTerm(thesaurusTerm),
                this.getAppLocale()
            )
        },

        toggleIsFolded() {
            this.isFolded = !this.isFolded
        },
    },
})
